import { NgModule } from '@angular/core'
import { provideConfig } from '@spartacus/core'
import { FsComponentConverter } from 'fs-spartacus-common'
import { TRAINING_LIST_CONVERTER } from './index'
import { TrainingListConverter } from './training-list.converter'

@NgModule({
  providers: [
    provideConfig({
      featureModules: {
        trainingListFeature: {
          module: () => import('./training-list.module').then((m) => m.TrainingListModule),
          cmsComponents: ['training_list'],
        },
      }
    }),
    {
      provide: TRAINING_LIST_CONVERTER,
      useExisting: TrainingListConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        training_list: TRAINING_LIST_CONVERTER
      },
      multi: true
    }
  ]
})
export class TrainingListFeatureModule {
}
